import {SierraCanvas} from '../../classes/sierraCanvas';
/**
 * @name resizeImage
 * @description this simulates the effects of fastResampleHermite but is 100+ times faster
 * all it actually does is render an image twice, with the second having a slight
 * offset and reduced opacity
 */

export const resizeImage = (canvas: any, width: number, height: number) => {
  const outCnv = new SierraCanvas(width, height);

  outCnv.drawImage(canvas, 0, 0, width, height);

  return outCnv.canvas;
};
